import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ICONS from "../../../../../assets/Icons";
import BankDetails from "../../../../../components/_utils/AccountCreationComponents/BankDetails";
import ActiveInactiveAssociatePopup from "../../../../../components/_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import CommonAlertCard from "../../../../../components/_utils/CommonAlertCard";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import ConfidentialCard from "../../../../../components/_utils/TransactionCommonComponents/ConfidentialCard";
import TEXT from "../../../../../utils/globalText";
import ConfirmBtnAccCreation from "../../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";

const ReimbursementBankEdit = ({
  manualVirtualAccount,
  setManualVirtualAccount,
  ifscData,
  originalManualVirtual,
  setBankLookupNext,
  bankLookupNext,
  payload,
  setPayload,
  activeStep,
  bankAccountType,
  setBankNewMessage,
  setCreateNewEdit,
  benebankLookData,
  isBankLookupComplete,
  hasAssociationResult,
  isIFSCValid,
  verifyBankisLoading,
  isBankLinkedAccount,
  accActiveInactiveState,
  setAccActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  id,
}) => {
  const isBankError = useSelector(
    (state) => state.sharedResources.verifyBankAccountError,
  );
  const {
    verifyBankAccountData: bankStatus,
    ifscDetailsLoading,
    ifscDetailsError,
    bankLookupError,
  } = useSelector((state) => state.sharedResources);
  const [showManualToggle, setShowManualToggle] =
    useState(manualVirtualAccount);
  const [virtualAccount, setVirtualAccount] = useState(false);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);

  useEffect(() => {
    if (!manualVirtualAccount) setShowManualToggle(false);
  }, [payload?.bank_account, payload?.ifsc_code]);

  const associatedAccounts =
    benebankLookData?.beneficiary_accounts ??
    benebankLookData?.field_force_accounts;
  const verifiedManualVirtualAccount =
    bankStatus?.status === true &&
    bankStatus?.verification_details?.[0]?.is_virtual === "Y" &&
    bankStatus?.verification_details?.[0]?.virtual_account_type === "manual";
  const noAssociatedAccountsFound =
    isBankLookupComplete &&
    (bankLookupError === true ||
      (Boolean(benebankLookData) &&
        (!Array.isArray(associatedAccounts) ||
          associatedAccounts.length === 0)));
  const hasAssociatedAccounts =
    isBankLookupComplete &&
    benebankLookData?.status === true &&
    Array.isArray(associatedAccounts) &&
    associatedAccounts.length > GlobalConfiguration.lengthCheckZero;

  const dropDownOptions = [
    "Beneficiary account",
    "Reimbursement account",
    "Field force account",
    "Tax account",
  ];

  const isManualToggleVisible =
    isIFSCValid &&
    ifscData &&
    (manualVirtualAccount || showManualToggle || isBankError === true);
  const isAutomatedVirtualAccount =
    !manualVirtualAccount &&
    !verifiedManualVirtualAccount &&
    isIFSCValid &&
    /[a-z]/i.test(payload?.bank_account || "");
  const hasAutomatedVirtualAccount =
    isAutomatedVirtualAccount ||
    (!manualVirtualAccount &&
      !verifiedManualVirtualAccount &&
      isIFSCValid &&
      bankStatus?.verification_details?.[0]?.is_virtual === "Y");

  useEffect(() => {
    setVirtualAccount(hasAutomatedVirtualAccount);

    if (
      hasAutomatedVirtualAccount &&
      payload?.virtual_account_type !== "automated"
    ) {
      setPayload({
        ...payload,
        virtual_account_type: "automated",
      });
    }
  }, [
    isAutomatedVirtualAccount,
    hasAutomatedVirtualAccount,
    manualVirtualAccount,
    bankStatus?.verification_details,
    payload,
    setPayload,
  ]);
  useEffect(() => {
    if (manualVirtualAccount && isIFSCValid) {
      setBankVerificationStatus(true);
    } else if (
      !manualVirtualAccount &&
      !verifyBankisLoading &&
      bankStatus?.status !== true
    ) {
      setBankVerificationStatus(false);
    }
  }, [
    manualVirtualAccount,
    isIFSCValid,
    verifyBankisLoading,
    bankStatus?.status,
  ]);

  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      if (manualVirtualAccount) {
        setCreateNewEdit(false);
        return;
      }
      if (virtualAccount && isIFSCValid) setCreateNewEdit(true);
      if (isBankLinkedAccount) {
        return;
      }
      if (isBankError === true) {
        setCreateNewEdit(true);
      }
      if (
        bankStatus?.verification_details?.[GlobalConfiguration.lengthCheckZero]
          ?.account_exists === "N" &&
        !benebankLookData
      ) {
        setCreateNewEdit(true);
      }
      if (payload.bank_account === payload.old_bank_account) {
        if (!(virtualAccount && isIFSCValid)) {
          setCreateNewEdit(false);
        }
        setBankNewMessage(true);
      }
      if (
        payload.bank_account !== payload.old_bank_account &&
        benebankLookData
      ) {
        setCreateNewEdit(true);
      }
    }
  }, [
    benebankLookData,
    isBankError,
    bankStatus,
    payload,
    isBankLinkedAccount,
    isIFSCValid,
    virtualAccount,
    manualVirtualAccount,
  ]);

  return (
    <>
      <div className="max-w-tab-width-normal w-full mx-auto">
        <CommonLayout>
          <div className="w-width-full">
            {hasAssociationResult &&
              (bankAccountType.type === "blocked" &&
              !isBankError &&
              !virtualAccount ? (
                <CommonAlertCard
                  icon={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                  texts="To unblock this account, please contact customer support"
                />
              ) : null)}
            {hasAutomatedVirtualAccount && (
              <div className="mb-margin-md">
                <CommonAlertCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title="Virtual Account Detected"
                  texts={[
                    "Account could not be verified as it is a virtual account.",
                    "Self-verify and proceed with caution.",
                  ]}
                />
              </div>
            )}
            {isBankLinkedAccount && isIFSCValid && (
              <div className="mb-margin-md">
                <CommonAlertCard
                  icon={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                  texts="The bank account is already linked to the provided PAN. To proceed, update the bank details associated with the account."
                />
              </div>
            )}
            <div className=" h-fit w-full">
              <BankDetails
                manualVirtualAccount={manualVirtualAccount}
                setManualVirtualAccount={setManualVirtualAccount}
                ifscData={ifscData}
                payload={payload}
                setPayload={setPayload}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
                setShowDetails={() => {}}
                setAssociatedNext={() => {}}
                ownerAccIfscError={ifscDetailsError}
                ownerAccIfscLoading={ifscDetailsLoading}
              />
            </div>
          </div>
          <div className="w-width-full flex flex-col">
            {isManualToggleVisible &&
              ifscData &&
              !verifyBankisLoading &&
              (isBankError || manualVirtualAccount || showManualToggle) && (
                <div className="mb-margin-md">
                  <ConfidentialCard
                    isPreview={false}
                    isEnabled={
                      !verifiedManualVirtualAccount &&
                      !(
                        originalManualVirtual &&
                        manualVirtualAccount &&
                        payload.bank_account === payload.old_bank_account &&
                        payload.ifsc_code === payload.old_ifsc_code
                      )
                    }
                    icon={ICONS.VIRTUAL_ACCOUNT}
                    title={TEXT.MARK_VIRTUAL_ACCOUNT}
                    note={TEXT.VIRTUAL_ACCOUNT_NOTE}
                    toggleState={manualVirtualAccount}
                    onToggle={() => {
                      const next = !manualVirtualAccount;
                      setManualVirtualAccount(next);
                      setShowManualToggle(true);
                      setCreateNewEdit(true);
                      setPayload({
                        ...payload,
                        virtual: next,
                        virtual_account_type: next ? "manual" : "",
                        skip_account_verification: next ? "Y" : "N",
                      });
                    }}
                  />
                </div>
              )}
            {payload.bank_account !== payload.old_bank_account &&
              hasAssociatedAccounts &&
              isIFSCValid &&
              !isBankError &&
              !isBankLinkedAccount &&
              !manualVirtualAccount &&
              !virtualAccount && (
                <div style={{ overflow: "hidden" }}>
                  <div className="animate-slideInFromRight">
                    <ConfirmBtnAccCreation
                      type="bank"
                      status={benebankLookData?.status}
                      isIFSCValid={isIFSCValid}
                      isBankError={isBankError}
                      lookupNext={bankLookupNext}
                      nextButtonEnabled={!bankLookupNext}
                      handleClick={() =>
                        setBankLookupNext((confirmed) => !confirmed)
                      }
                    />
                  </div>
                </div>
              )}
            <div
              style={{
                display:
                  noAssociatedAccountsFound ||
                  (benebankLookData?.status &&
                    associatedAccounts?.length >
                      GlobalConfiguration.lengthCheckZero) ||
                  virtualAccount
                    ? "block"
                    : (isIFSCValid && isBankError) || isManualToggleVisible
                      ? "none"
                      : "block",
              }}
            >
              <ActiveInactiveAssociatePopup
                dropDownNo={1}
                flow={
                  noAssociatedAccountsFound
                    ? "notFoundBank"
                    : isBankError === true
                      ? "hideAssociate"
                      : isBankLinkedAccount && isIFSCValid
                        ? "Existing"
                        : hasAssociationResult && associatedAccounts?.length
                          ? "Bank"
                          : hasAssociationResult
                            ? "notFoundBank"
                            : "defaultBank"
                }
                dropDownOptions={dropDownOptions}
                ifsc={payload?.ifsc_code}
                bank={payload?.bank_account}
                pan={payload?.pan_no}
                accActiveInactiveState={accActiveInactiveState}
                setAccActiveInactiveState={setAccActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                activeAssociateId={id}
                ifscLength={payload?.ifsc_code?.length}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};
export default ReimbursementBankEdit;
